module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    class: _vm.classes,
    attrs: {
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm._change
    }
  }, [(!!_vm.placeHolder && !_vm.multiple) ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.placeHolder))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.options), function(option) {
    return (_vm.options.length > 0) ? _c('option', {
      domProps: {
        "value": option[_vm.optionValue]
      }
    }, [_vm._v(_vm._s(option[_vm.optionText]))]) : _vm._e()
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cda532fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/selectbox/selectbox.vue
// module id = 717
// module chunks = 85